import classNames from 'classnames';
import React, { ComponentType, HTMLAttributes, ReactNode } from 'react';
import { Backdrop as DefaultBackdrop, BackdropProps } from '../../Backdrop';
import ModalBody from '../ModalBody/ModalBody';
import { ModalContext } from '../ModalContext';
import ModalFooter from '../ModalFooter/ModalFooter';
import ModalHeader from '../ModalHeader/ModalHeader';
import styles from './BaseModal.module.css';

export type ModalProps = {
  Backdrop?: ComponentType<BackdropProps>;
  children: ReactNode;
  closeOnBackdropClick?: boolean;
  onClose?: () => void;
  show: boolean;
  disableOnClose?: boolean;
} & HTMLAttributes<HTMLDivElement>;

const Modal = ({
  Backdrop = DefaultBackdrop,
  children,
  className,
  closeOnBackdropClick = false,
  disableOnClose = false,
  onClose,
  show,
  ...props
}: ModalProps) => {
  const contextValue = { onClose, disableOnClose };
  const containerClassName = classNames(styles.container, className);

  const onBackdropClick = () => {
    if (closeOnBackdropClick && onClose) {
      onClose();
    }
  };

  const stopEventPropagation = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
  };

  return (
    <ModalContext.Provider value={contextValue}>
      <Backdrop show={show} onClick={onBackdropClick}>
        <div
          className={containerClassName}
          onClick={stopEventPropagation}
          {...props}
        >
          {children}
        </div>
      </Backdrop>
    </ModalContext.Provider>
  );
};

Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;

export default Modal;
